/**
 * will remove this service and use only single shared servie
 */

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import apiUrlPoint from '../life-config/apiEndPoints.json';
import { catchError, map } from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpService } from '../services/http.service';
@Injectable()
export class SharedApiService {

    // Decalring class members

    apiUrl: object = apiUrlPoint.apiEndPoints;
    // proposalId: string;
    // uuid: string;
    proposalRes: any;
    documentRes: any;
    tabInfoListDetail: any;
    apiInitial = apiUrlPoint.apiEndPoints;
    /**
     * Is it required to make subject every time for each one
     * TODOs find a way to mimize it
     */
    invokeEvent: Subject<any> = new Subject();
    invokeBIEvent: Subject<any> = new Subject();
    invokeDobEvent: Subject <any> = new Subject();
    invokeProposalEvent: Subject <any> = new Subject();
    invokeUIDob: Subject <any> = new Subject();
    tabEventData: Subject <any> = new Subject();
    crntTabActive: Subject <any> = new Subject();
    validateRider: Subject <any> = new Subject();
    returnErrorMessage: Subject <any> = new Subject();
    getAddOnsDataInfo: Subject <any> = new Subject();
    setErrorInfo: Subject<any> = new Subject();

    indexData: any;

    someValue = 'someVal';
    constructor(

        private apiService: ApiService,
        private sanitizationService: DomSanitizer,
        private http: HttpService

    ) {

    }

    /**
     * get  Document data
     *
     */

     getDocumentInfo(res: any) {
        this.documentRes = res;
        // return res;
        // console.log('this is response from input tag',res);
     }

     getDocumentData() {
        return  this.documentRes;
     }

     getErrroInfo(data: any){
        this.setErrorInfo.next(data);
    }

     /**
      * Transmitting data
      */

    callMethodofDocumentData() {
    this.invokeEvent.next(this.someValue);
    }

    callMethodOfSecondComponent(dataEmitted) {
    this.invokeEvent.next(dataEmitted);
    }

    callMethodForBIComponent(BIDataEmitted) {
    this.invokeBIEvent.next(BIDataEmitted);
    }

    callMethodForDOBComponent(DobDataEmitted) {
    this.invokeDobEvent.next(DobDataEmitted);
    }

    callMethodForUIDOBComponent(DobDataValue) {
    this.invokeUIDob.next(DobDataValue);
    }

    callMethodForProposalComponent(proposalDataEmitted: any) {
    this.invokeProposalEvent.next(proposalDataEmitted);
    }

    setAddonsData(addOnDataEmiited: any) {
        this.getAddOnsDataInfo.next(addOnDataEmiited);
    }

    getTabInfo(tabDataObtained) {
        this.tabInfoListDetail = [...tabDataObtained];
        this.storeTabInfo();
        this.tabEventData.next(tabDataObtained);
    }

    getNextCrntActiveTab(nextTaInfo, indexData) {
        this.indexData = indexData;
        this.setIndexVal();
        this.crntTabActive.next (nextTaInfo);
    }

    getRiderValidation(booleanvalueRecieved) {

        this.validateRider.next(booleanvalueRecieved);
    }


    setErrorMessage(errorMessageObtained) {

        this.returnErrorMessage.next(errorMessageObtained);
    }

    /**
     * Store tab info as intially tab is not beig susbcribed without click
     */

    storeTabInfo() {
        return this.tabInfoListDetail;
    }

    setIndexVal() {
        return this.indexData;
    }


    /** check for document whther this piece of code is using in DOC section */

    /**
     * Get Age and return age
     */

    // getAgeInyears(date: Date) {

    //     const today = new Date();
    //     const dob = new Date(date);
    //     dob.setHours(0, 0, 0, 0);
    //     const diffInEpoch = today.getTime() - dob.getTime();
    //     return  Math.floor(diffInEpoch / (1000 * 3600 * 24) / 365.25);

    // }


    getAgeInyears(dob) {

        /**
         * Get year on subtracting from date of birth year from current year
         * then compare date  and ignore year for a while
         * then assigning years
         */
        const d = new Date(dob);
        const now = new Date();

        // Get year difference from date of birth year
        let years = now.getFullYear() - d.getFullYear();

        // Compare dates ignoring years
        d.setFullYear(now.getFullYear());
        if (d > now) {
            years--;
        }

        const age = years;
        return age > -1 ? Math.floor(age) : 0;
    }

    /**
     * BI-Benefit Illustration
     * On certain field value change BI will update
     */

    getBenefitIllustration(proposalId, uuid) {
        return this.apiService.getPropsalInfo(this.apiUrl['apiV2LifeProposal'], proposalId, uuid, this.apiUrl['getBenefitIllustration'])
        .pipe(

            map(response =>  this.sanitizationService.bypassSecurityTrustResourceUrl(response['document'])),
            catchError(err => JSON.stringify(err))
        );


    }

    getBenefitIllustratioWithInsurerID(proposalId, uuid, productName, insurerName, queryParams) {
        return this.apiService.getBIWithInsurer(
            this.apiUrl['apiV2LifeProposal'], uuid , insurerName, productName, queryParams,
             proposalId)
        .pipe(

            map(response =>  this.sanitizationService.bypassSecurityTrustResourceUrl(response['document'])),
            catchError(err => JSON.stringify(err))
        );


    }


    getFinalBI(proposalId, uuid) {

        return this.apiService.getPropsalInfo(this.apiUrl['apiV2LifeProposal'], proposalId, uuid, this.apiUrl['getProposalForm'])
        .pipe(

            map(response => response),
            catchError(err => JSON.stringify(err))
        );
    }


    // Get Proposal Data from here

    getProposalInfo(proposalId, uuid) {

        return this.apiService.getPropsalInfoWithoutQueryParms(this.apiUrl['apiV2LifeProposal'], proposalId, uuid)
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(err))
            );

    }


    /**
     * Quotes generation  - it will be a shared resource as it will trigger on any chnage or proposal update
     */


    getQuote(proposalId, uuid) {

        return this.apiService.getPropsalInfo(this.apiUrl['apiV2LifeProposal'], proposalId, uuid,  this.apiUrl['getQuotations'])
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(err))
            );
    }

    /**
     * Old structure
     */
    getRecalculatedPremium(proposalId, uuid) {

        return this.apiService.getPropsalInfo(this.apiUrl['apiV2LifeProposal'], proposalId, uuid, this.apiUrl['reCalculatePremium'])
            .pipe(
                map(response => response),
                catchError(err => JSON.stringify(err))
            );

    }

    /**
     * New Structuyre
     */
    getRecalculatePremium(proposalId, uuid, initialUrl: string, recaluclatePremium: string, insurer?: string, product?: string ){

        return this.apiService.getRequestedResponse(initialUrl, proposalId, uuid, 'renewbuy-backend-header', recaluclatePremium , insurer, product)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(err))
        );




    }

    getInitialDocumentList(urlObtained: string, productModuleName: string ){

        return this.http.getRequest( urlObtained,  productModuleName)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(err))
        );

    }

    postInitatePaymentUrl(urlObtained: string, productModuleName: string ){

        return this.http.postRequest( urlObtained,  productModuleName)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(err))
        );

    }

    getPincodevalue(url, headers){
        return this.http.getRequest( url,  headers)
        .pipe(
            map(response => response),
            catchError(err => JSON.stringify(err))
        );


    }

}
